import ParallaxElement from '../classes/ParalaxComponent';

/**
* Coillect all elements and init
*/
const initParallaxElements = () => {
    const els = Array.from(document.querySelectorAll('[data-parallax]')).map((el) => {
        return new ParallaxElement(el);
    });
    


    const parllaxLoop = () =>{
        els.forEach(el => el.update());
        requestAnimationFrame(parllaxLoop);
    };

    /**
     * Start loop if elements exists
     */
    if (els.length) {
        parllaxLoop();
    }
};

(() => {
    initParallaxElements();
})();

